import React from "react";
import Card from "./Card";
import "./HeaderCard.css";

const HeaderCard = ({ logo, title, subtitle, description }) => {
  return (
    <Card padding="30px">
      <div className="header1">
        <img src={logo} alt="logo" width="48" />
        <h2>{title}</h2>
        <h3>{subtitle}</h3>
        <p>{description}</p>
      </div>
    </Card>
  );
};

export default HeaderCard;
